import { render, staticRenderFns } from "./Trecho.vue?vue&type=template&id=72ce323b"
import script from "./Trecho.vue?vue&type=script&lang=js"
export * from "./Trecho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports